var loadFaqMeta_gql_default = `
query GetFaqMeta {
  MpMageplazaFaqsGetConfig {
    faq_home_page {
      seo {
        meta_description
        meta_keyword
        meta_title
      }
      title
    }
  }
}
`;
export {
  loadFaqMeta_gql_default as default
};
